export default { sha: '45bd492711937c35b81ffacd80c3ffadbb645d6f', buildNumber: 'undefined' }
